_ = require 'underscore'

# This library is intentially crashy, rather than returning bad version compares
Version = {}

class Version.Server
  constructor: (string) ->
    return null unless string

    parts = string.split('.')
    if parts.length > 0
      @parts = (parseInt(v, 10) || 0 for v in parts)
    else
      @parts = [0]

  toString: -> @parts.join('.')
  toJSON: -> @toString()

  lessThan: (compareVersion) ->
    compare = @compareTo(compareVersion)
    compare && compare < 0

  greaterThan: (compareVersion) ->
    compare = @compareTo(compareVersion)
    compare && compare > 0

  equalTo: (compareVersion) ->
    compare = @compareTo(compareVersion)
    compare && compare == 0

  # Returns the leftmost index (1-indexed) in which the versions differ,
  # counting from the right, or zero if they are equal. Positive if
  # first arg is greater, negative if second arg is greater.
  # 0.9.27.14 compared to 0.9.27.15 returns -1
  # 0.9.27 compared to 0.8.28 returns 2
  compareTo: (compareVersion) ->
    if _.isString(compareVersion)
      compareVersion = new Version.Server(compareVersion)
    else if compareVersion !instanceof Version.Server
      return null

    len = Math.max(@parts.length, compareVersion.parts.length)
    for [nA, nB] in _.zip(@parts, compareVersion.parts)
      nA ?= 0
      nB ?= 0
      if nA > nB then return len
      if nB > nA then return -len
      len--
    return 0

  @compareStringVersions: (vA, vB) ->
    new Version.Server(vA).compareTo(vB)

  supports: (clientVersion) ->
    min = clientVersion.minServerVersion
    max = clientVersion.maxServerVersion
    (!min || @greaterThan(min)) && (!max || @lessThan(max))

# Essentially a client-side compatible wrapper for schema.Deployment
class Version.Client
  constructor: (str) ->
    [@head, version] = str.split('-')
    @version = parseInt(version, 10)
    @patch = 0

  toString: -> "#{ @head }-#{ @fullVersion() }"
  toJSON: -> @toString()

  fullVersion: ->
    # If @version is 0, the compact will eat it
    _.compact([@version, @patch]).join('.') || 0

module.exports = Version



// WEBPACK FOOTER //
// ./app/scripts/lib/version.coffee